import { Component, computed, Input, Signal, signal, WritableSignal } from '@angular/core';
import { Categories, Rule } from 'src/app/models/types/Rule/Rule.type';
import { AssetComponent } from '../../asset/asset.component';
import { SharedModule } from 'src/app/modules/shared.module';
import { CategoryBodyComponent } from '../category-body/category-body.component';

enum Gender {
  Men, Ladies
}

@Component({
  selector: 'app-hew-category',
  imports: [
    SharedModule,
    CategoryBodyComponent
  ],
  templateUrl: './hew-category.component.html',
  styleUrl: './hew-category.component.scss'
})
export class HewCategoryComponent {

  @Input('rule') rule!: Rule;

  public selectedGender: WritableSignal<Gender> = signal(Gender.Men);

  public category: Signal<Categories[]> = computed(() => {
    let categories: Categories[] = [];
    try {
      categories = this.rule.subCategories[this.selectedGender()].discoverCategories;
    } catch (err) {
      console.log(err);
    }
    finally {
      return categories
    }
  })

}
